import {mergeCombatStats, resolveCombatStats} from "../../../utils/gameState/buildCombatStats";

const countUnits = (groups) => groups.reduce((sum, {count}) => sum + count, 0);

/**
 * Строки модалки итогов боя: по строке на игрока, у которого на прошедшем
 * этапе что-то изменилось (сводка редьюсера этапа, gameState.combatStats, см.
 * buildCombatStats). Выше — кто больше заработал очков и уничтожил отрядов.
 *
 * Состояние без сводки (запись до нее) — строки собираются из самих
 * уничтожений: отряды и очки известны, а урон и размер — нет (null, в строке
 * не показываются).
 *
 * @param {Object[]|null|undefined} combatStats - gameState.combatStats
 * @param {Object[]} combatResults - gameState.combatResults
 * @param {Object[]} players - игроки партии
 * @param {Object[]|null} [carriedStats] - сводка прошлых этапов, итоги которых
 *   игрок еще не видел (см. CARRY_COMBAT_RESULTS)
 * @returns {Object[]} строки сводки с найденным игроком (player)
 */
export const buildCombatResultsRows = (combatStats, combatResults, players, carriedStats = null) => {
  const stageStats = resolveCombatStats(combatStats, combatResults, players);
  const stats = carriedStats ? mergeCombatStats(carriedStats, stageStats) : stageStats;

  return stats
    .map((row) => ({...row, player: (players || []).find(({id}) => id === row.playerId)}))
    .filter((row) => row.player)
    .sort((left, right) => (right.winPoints - left.winPoints)
      || (countUnits(right.killedUnits) - countUnits(left.killedUnits))
      || ((right.damageDealt || 0) - (left.damageDealt || 0)));
};
